"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GridConfig {
    getColumn(column) {
        return this.columnConfigs[column];
    }
    getNumberOfColumns() {
        return this.columnConfigs.length;
    }
    canExpand(data) {
        return false;
    }
    setGrid(grid) {
        this.grid = grid;
        for (let column = 0; column < this.getNumberOfColumns(); column++) {
            this.getColumn(column).grid = grid;
        }
    }
}
exports.default = GridConfig;
//# sourceMappingURL=GridConfig.js.map